export default __webpack_public_path__ + "static/media/Tamara.eac376f4.png";